import { ILenderForm } from 'validation/lenders/createLenderValidationFactory';
import { ILenderInformationData } from './ILenderInformation';

export const convertLenderInformationDataToLenderForm = (data: ILenderInformationData): ILenderForm => ({
  name: data.lender.name,
  address: {
    streetAddress: data.address.street_address || '',
    unit: data.address.unit || undefined,
    city: data.address.city || '',
    state: data.address.state || '',
    zip: data.address.zip_code || '',
  },
  mortgageeClause: data.lender.mortgageeClause,
  masterEmail: data.lender.masterEmail,
  wfgId: data.lender.wfgId,
  bulkRateQualified: data.lender.bulkRateQualified,
  refiPremiumOrReportFee: data.lender.defaultFeeType,
  refiDiscountedClosingFee: data.lender.refiDiscountedClosingFee,
  refiPageCounts: {
    lienRelease: data.refiPageCounts.lienReleasePages,
    mortgage: data.refiPageCounts.mortgagePages,
    deed: data.refiPageCounts.deedPages,
    noticeOfSettlement: data.refiPageCounts.noticeOfSettlementPages,
    subordinationAgreement: data.refiPageCounts.memorandumPages,
    assignment: data.refiPageCounts.assignmentPages,
  },
  purchasePageCounts: {
    lienRelease: data.purchasePageCounts.lienReleasePages,
    mortgage: data.purchasePageCounts.mortgagePages,
    deed: data.purchasePageCounts.deedPages,
    noticeOfSettlement: data.purchasePageCounts.noticeOfSettlementPages,
    subordinationAgreement: data.purchasePageCounts.memorandumPages,
    assignment: data.purchasePageCounts.assignmentPages,
  },
  coBranded: data.lender.coBranded,
  logoUrl: data.lender.logoUrl,
});
